export const errorMessages = {
    anError: "An error occured: ",
    fetchCities: "Failed to fetch cities: ",
    fetchDistricts: "Failed to fetch districts: ",
    fetchCustomers: "Failed to fetch customers: ",
    fetchUsers: "Failed to fetch users: ",
    errorMessage: "Error message: ",
    erpTransfer: "Aktarım yapılırken hata meydana geldi. Hata mesajı: ",
    lowEndAmountRange: "Bakiye Aralığı başlangıç değeri bitiş değerinden küçük olamaz."
}